import { Random } from '@framework/Random';
import type { DescriptionPanelId } from 'balus-common';

const length = 20;
export const newDescriptionPanelId = (): DescriptionPanelId => Random.generateRandomID(length);
